import { render, staticRenderFns } from "./PlaceCommentsModal.vue?vue&type=template&id=176144bc&scoped=true"
import script from "./PlaceCommentsModal.vue?vue&type=script&lang=js"
export * from "./PlaceCommentsModal.vue?vue&type=script&lang=js"
import style0 from "./PlaceCommentsModal.vue?vue&type=style&index=0&id=176144bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176144bc",
  null
  
)

export default component.exports